import styled from 'styled-components/macro';
import InfoTooltip from '../../../../components/InfoTooltip';

export const CustomInfoTooltip = styled(InfoTooltip)`
  padding-right: 6px;
  cursor: pointer;
`;
